/**
 * The Boone lockup — **icon + lowercase `iamboone` + `@boone`** (ADR 0004; the `branding`
 * skill), in the one place every surface here takes it from.
 *
 * It was previously spelled twice, and incompletely: the card had the full lockup and the app
 * chrome had the mark alone, with a comment arguing the handle did not belong in a header. The
 * #293 wireframes settle it the other way — the masthead carries all three — and the skill is
 * unambiguous that the standard lockup is the three together. Two sizes rather than two
 * components, so a third surface cannot quietly invent a fourth arrangement.
 *
 * The mark is the **copied asset** (`public/assets/icon-180.png`, the cream lowercase "b" with
 * the pilotfish curl on a forest tile), never a CSS approximation of it: the artboards draw a
 * forest square with a letter in it because a mock has no bundle, and this has the real thing.
 */
export function Lockup({ size = "card" }: { size?: "card" | "chrome" }) {
  const chrome = size === "chrome";
  const mark = chrome ? 34 : 48;
  return (
    <div className={`lockup${chrome ? " lockup--chrome" : ""}`}>
      <img
        className="lockup__mark"
        src="/assets/icon-180.png"
        alt="I am Boone"
        width={mark}
        height={mark}
      />
      <span className="lockup__names">
        <span className="wordmark">iamboone</span>
        <span className="handle">@boone</span>
      </span>
    </div>
  );
}
